import React from 'react';

import Medicare from 'Assets/landing-page/medicare.png';
import { Button } from 'DesignLibrary/atoms';
import Text from 'Shared/Text';
import { getMedicareCalloutUrl, trackMedicareProductSelect } from 'Utils/medicare';

import { MedicareContainer, Wrapper } from './styled';
import { MedicareDestination } from '../../../constants';

export interface MedicareCalloutProps {
  client: string;
  isNextClicked: boolean;
  medicareDestination: MedicareDestination;
}

export const MedicareCallout2025 = ({ client, isNextClicked, medicareDestination }: MedicareCalloutProps) => {
  const url = getMedicareCalloutUrl(medicareDestination, client);

  const handleClick = () => {
    trackMedicareProductSelect(medicareDestination, url);
  };

  return (
    <Wrapper>
      <MedicareContainer isNextClicked={isNextClicked}>
        <div className="rounded-container">
          <div className="medicare">
            <div className="text">
              <h2>
                <Text field="unified_landing_page.medicare_callout.text_primary" />
                <span>
                  <Text field="unified_landing_page.medicare_callout.text_secondary" />
                </span>
              </h2>
              <div className="link">
                <Button
                  stretch
                  url={url}
                  onClick={handleClick}
                  buttonType="primary"
                  iconRight="ArrowRight"
                  className="button primary"
                >
                  <Text field="unified_landing_page.medicare_callout.cta_button_v2" />
                </Button>
              </div>
            </div>
            <div className="img">
              <img src={Medicare} alt="hand with health icons" />
            </div>
          </div>
        </div>
      </MedicareContainer>
    </Wrapper>
  );
};
